module.exports = __webpack_public_path__ + "img/icon_sub@3x.7ab79cdb.png";